import React, { Dispatch, SetStateAction, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';

import { useHttpUtils } from '../../../Utilities/useHttpUtils';
import { useNavigate } from 'react-router';
import useAlert from '../../../Alerts/useAlert';
import usePrivileges from '../../../Auth/usePrivileges';
import { LotDetailContext } from '../../../Contexts/LotDetailContext';
import useConfigurationData from '../../../Utilities/useConfigurationData';
import CommentDialog from "../../../Dialogs/CommentDialog";

interface DeleteLotButtonProps {
    setLoading: Dispatch<SetStateAction<boolean>>
}

function DeleteLotButton({ setLoading }: DeleteLotButtonProps) {

    const { t } = useTranslation();
    const { setAlert } = useAlert();
    const { fetchDataAuthenticated } = useHttpUtils();
    const { getConfigurationDataBoolean } = useConfigurationData();
    const navigate = useNavigate();

    const { lotDetail: { summary: { lotNumber, businessUnitCode, businessUnitId } } } = useContext(LotDetailContext);

    let supervisorCanDelete = getConfigurationDataBoolean("Grading.SupervisorCanDelete", businessUnitId, false);

    const { admin, supervisor } = usePrivileges(businessUnitCode);

    const [showDeleteLotCommentDialog, setShowDeleteLotCommentDialog] = useState(false);

    const deleteLot = async (comment: string) => {
        setLoading(true);

        fetchDataAuthenticated(`api/v1/lot/${lotNumber}`, 'DELETE', JSON.stringify(comment))
            .then(async response => {
                if (response.ok) {
                    setAlert("success", "Success", `Deleted lot ${lotNumber}`);
                    navigate('/lots');
                } else {
                    let message = await response.text();
                    throw new Error(`Failed to delete the lot. ${message}`);
                }
            })
            .catch(error => {
                setAlert("danger", "Error", error.message);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <>
            <Button variant="danger"
                hidden={!(admin || (supervisorCanDelete && supervisor))}
                onClick={() => setShowDeleteLotCommentDialog(true)}>
                {t('LotDetails.Summary.DeleteLot')}
            </Button>
            <CommentDialog
                showDialog={showDeleteLotCommentDialog}
                closeDialog={() => setShowDeleteLotCommentDialog(false)}
                onSave={deleteLot} />
        </>
    );
}

export default DeleteLotButton;